import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
export interface TabProps {
  items: string[];
  value: number;
  handleChange: (value: number) => void;
}
export function UserTabs(props: TabProps) {
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <Tabs
        value={props.value}
        variant="scrollable"
        scrollButtons="auto"
        onChange={(event: React.SyntheticEvent, value: number) => {
          props.handleChange(value);
        }}
        TabIndicatorProps={{
          style: { display: "none" },
        }}
        sx={{
          height: "35px",
          ".MuiTabs-flexContainer": {
            minHeight: "35px !important",
            height: "35px !important",
            gap: "3rem",
            ".MuiTab-root": {
              padding: "0px 10px !important",
              color: "#999999",
              "&:hover": {
                backgroundColor: "#e5e1e1",
              },
            },
            ".Mui-selected": {
              color: "var(--primary-color)",
              backgroundColor: "none",
              borderBottom: "2px solid var(--primary-color)",
            },
          },
        }}
      >
        {props.items.map((item: any, index: number) => {
          return (
            <Tab
              sx={{
                textTransform: "none",
                fontSize: "1.8rem",
                fontWeight: "600",
                color: "#343434",
                height: "35px",
              }}
              label={item}
              {...a11yProps(index)}
            />
          );
        })}
      </Tabs>
    </>
  );
}
